export const removeEmptyEntries = (object = {}) => {
    Object.keys(object).forEach((key) => {
        const value = object[key];
        (value === null || value === undefined || value === '') && delete object[key];
    });

    return object;
};
